import React, { useMemo } from 'react';
import Button from '../../button/button';
import './style';
import { CaretLeft, CaretRight } from '@phosphor-icons/react';

const generatePages = (currentPage, totalPages) => {
  const pages = [];
  const delta = 2;
  const range = [];

  if (totalPages <= 2) {
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
    return pages;
  }

  for (let i = Math.max(2, currentPage - delta); i <= Math.min(totalPages - 1, currentPage + delta); i++) {
    range.push(i);
  }

  if (currentPage - delta > 2) {
    pages.push(1);
    pages.push('...');
  } else {
    for (let i = 1; i < Math.max(2, currentPage - delta); i++) {
      pages.push(i);
    }
  }

  pages.push(...range);

  if (currentPage + delta < totalPages) {
    pages.push('...');
    pages.push(totalPages);
  } else if (!range.includes(totalPages)) {
    pages.push(totalPages);
  }

  return pages;
};

const PaginationButton = (props) => {
  const {
    type,
    content,
    isSelected,
    isDisabled,
    onChange,
  } = props;

  return (
    <div className={`pagination-button-wrapper text-center ${isSelected ? ' selected' : ''}`}>
      {content === 'pagination_ellipses' ? (
        <div className="ellipsis flex items-center justify-center text-grey-70 label-14 rounded-lg p-2">
          ...
        </div>
      ) : (
        <div
          className={`pagination-button flex items-center justify-center label-14 rounded-lg p-2 text-grey-70 ${isDisabled ? 'disabled' : 'cursor-pointer'}`}
          onClick={() => onChange(content)}
        >
          {content}
        </div>
      )}
    </div>
  );
};

const Pagination = (props) => {
  const {
    totalPages,
    selectedPage,
    pageSize,
    onChange,
    isDisabled,
  } = props;

  const pages = useMemo(() => {
    return generatePages(selectedPage, totalPages);
  }, [totalPages, selectedPage]);

  return (
    <div className="pagination-container px-6 pb-4 pt-6 flex items-center justify-between">
      <Button
        className="previous-btn"
        type="tertiary"
        size="small"
        iconLeft={<CaretLeft />}
        onClick={() => onChange(selectedPage - 1)}
        disabled={isDisabled || selectedPage === 1}
      >
        Previous
      </Button>
      <div className="pagination-wrapper flex">
        {pages?.map((page) => (
          <PaginationButton
            type={typeof page === 'number' ? 'number' : 'icon'}
            content={typeof page === 'number' ? page : 'pagination_ellipses'}
            isSelected={selectedPage === page}
            isDisabled={isDisabled}
            onChange={onChange}
          />
        ))}
      </div>
      <Button
        className="next-btn"
        type="tertiary"
        size="small"
        iconRight={<CaretRight />}
        onClick={() => onChange(selectedPage + 1)}
        disabled={isDisabled || (selectedPage === totalPages)}
      >
        Next
      </Button>
    </div>
  );
};

export default Pagination;
